// @flow
import React from 'react';

type Props = {
  size?: number | string,
  width?: number | string,
  height?: number | string,
  color?: string,
  stroke?: string,
  strokeWidth?: number | string,
  className?: string,
  style?: Object,
};

const ClockIcon = ({
  size = 16,
  width,
  height,
  color,
  stroke,
  strokeWidth = 2,
  className,
  style,
}: Props) => {
  const iconStroke = color || stroke || 'currentColor';
  const iconWidth = width || size;
  const iconHeight = height || size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
      style={{ flexShrink: 0, ...style }}
    >
      <path
        d="M11 5V11L15 13M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke={iconStroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ClockIcon;
